import React, { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import { Button, Modal, Panel } from "components/bootstrap";
import DocumentationLink from "components/support/DocumentationLink";
import FormDataContext from "integrations/contexts/FormDataContext";
import { ApiContext } from "integrations/aws/context/Api";
import { SidebarContext } from "integrations/aws/context/Sidebar";
import useFetch from "integrations/hooks/useFetch";
import FormWrap from "integrations/aws/common/FormWrap";
import ValidatedInput from "integrations/aws/common/ValidatedInput";
import { ApiRoutes, DocsRoutes } from "integrations/aws/common/Routes";
import { renderOptions } from "integrations/aws/common/Options";
import formValidation from "integrations/aws/utils/formValidation";
import Spinner from "components/common/Spinner";
import useProductName from "brand-customization/useProductName";
import { toAWSRequest } from "integrations/aws/common/formDataAdapter";
import FormAdvancedOptions from "../FormAdvancedOptions";
const AutoSetupContent = styled.div`
  margin-bottom: 9px;
`;
const LoadingContent = styled(Modal.Body)`
  text-align: center;
`;
const StyledSpinner = styled(Spinner)`
  font-size: 48px;
  color: #702785;
`;
const LoadingMessage = styled.p`
  font-size: 16px;
  font-weight: bold;
  padding-top: 15px;
  color: #a6afbd;
`;
const KinesisStreams = ({ onChange, onSubmit, toggleSetup = () => {
} }) => {
  const { formData } = useContext(FormDataContext);
  const [formError, setFormError] = useState(null);
  const { availableStreams, setLogData } = useContext(ApiContext);
  const { clearSidebar, setSidebar } = useContext(SidebarContext);
  const productName = useProductName();
  const [logDataStatus, setLogDataUrl] = useFetch(
    null,
    (response) => {
      setLogData(response);
      onSubmit();
    },
    "POST",
    toAWSRequest(formData, {
      region: formData.awsCloudWatchAwsRegion.value,
      stream_name: formData.awsCloudWatchKinesisStream ? formData.awsCloudWatchKinesisStream.value : ""
    })
  );
  useEffect(() => {
    setSidebar(
      /* @__PURE__ */ React.createElement(Panel, { bsStyle: "info", header: /* @__PURE__ */ React.createElement("span", null, "Don't see the stream you need?") }, /* @__PURE__ */ React.createElement(AutoSetupContent, null, /* @__PURE__ */ React.createElement("p", null, "At least one Kinesis stream must exist in the specified region in order to continue with the setup. The log stream must contain at least a few log messages."), /* @__PURE__ */ React.createElement("p", null, productName, " also supports the ability to create a Kinesis stream for you and subscribe it to a CloudWatch log group of your choice. Please be aware that this option will create additional resources in your AWS environment that will incur billing charges.")), /* @__PURE__ */ React.createElement(
        Button,
        {
          onClick: () => {
            clearSidebar();
            toggleSetup();
          },
          type: "button"
        },
        "Setup Kinesis Automatically"
      ))
    );
  }, [clearSidebar, productName, setSidebar, toggleSetup]);
  useEffect(() => {
    if (logDataStatus.error) {
      setLogDataUrl(null);
      setFormError({
        full_message: logDataStatus.error,
        nice_message: /* @__PURE__ */ React.createElement("span", null, "We were unable to find any logs in this Kinesis stream. Please select a different Kinesis stream.")
      });
    }
  }, [logDataStatus.error, setLogDataUrl]);
  const handleSubmit = () => {
    setLogDataUrl(ApiRoutes.INTEGRATIONS.AWS.KINESIS.HEALTH_CHECK);
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Modal, { show: logDataStatus.loading, bsSize: "small", onHide: () => {
  }, closable: false }, /* @__PURE__ */ React.createElement(LoadingContent, null, /* @__PURE__ */ React.createElement(StyledSpinner, null), /* @__PURE__ */ React.createElement(LoadingMessage, null, "This request may take a few moments."))), /* @__PURE__ */ React.createElement(
    FormWrap,
    {
      onSubmit: handleSubmit,
      buttonContent: "Verify Stream & Format",
      loading: logDataStatus.loading,
      error: formError,
      disabled: formValidation.isFormValid(["awsCloudWatchKinesisStream"], formData),
      title: "Select Kinesis Stream",
      description: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("p", null, "Below is a list of all Kinesis streams found within the specified AWS account."), /* @__PURE__ */ React.createElement("p", null, "Please select the stream you would like to read messages from, or follow the\xA0", /* @__PURE__ */ React.createElement(
        DocumentationLink,
        {
          page: DocsRoutes.INTEGRATIONS.AWS.AWS_KINESIS_CLOUDWATCH_INPUTS,
          text: "AWS Kinesis/CloudWatch Input "
        }
      ), "documentation for more details on this set up."))
    },
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        id: "awsCloudWatchKinesisStream",
        type: "select",
        fieldData: formData.awsCloudWatchKinesisStream,
        onChange,
        label: "Select Stream",
        required: true
      },
      renderOptions(availableStreams, "Select Kinesis Stream")
    ),
    /* @__PURE__ */ React.createElement(FormAdvancedOptions, { onChange })
  ));
};
export default KinesisStreams;
